import './App.css';
import App from './components/AppRoutes.tsx';

function AppWrapper() {
  return <App />;
}

export default AppWrapper;
